import { useFormik } from "formik";
import { useEffect } from "react";

// Internal Imports
import EditTextForm from "../../../common/components/EditTextForm/EditTextForm";
import InputImage from "../../../common/components/InputImage/InputImage";
import MarginInput from "../../../common/components/MarginInput/MarginInput";
import Paint from "../../../common/components/Paint/Paint";
import SelectBox from "../../../common/components/SelectBox/SelectBox";
import { COLORS } from "../../../common/constants/colors";
import GroupRow from "../../../common/components/GroupRow/GroupRow";
import globalStyle from "../../../common/styles/globalStyle.module.css";
import { Mode } from "../../../common/types/AllTypes";
import { useForm } from "../../../contexts/form";
import { useListDepartmentByUer } from "../../../hooks/useListDepartment";
import useListPuesto from "../../../hooks/useListPuesto";
import { hasLowerChar, hasNumber, hasSymbols, hasUpperChar } from "../../../common/constants/Utilities";
import { useAuth } from "../../../contexts/auth";

interface Props {
    setCanGoNext: React.Dispatch<React.SetStateAction<boolean>>;
    setCanGoBack: React.Dispatch<React.SetStateAction<boolean>>;
    mode: Mode;
}


const StepThree = ({ setCanGoNext, setCanGoBack, mode }: Props) => {

    // States
    const { loadingDeparment, listDepartment } = useListDepartmentByUer();
    const { loadingPuesto, listPuesto } = useListPuesto();
    const { setUserInformationForm, userInformationForm, userNameCreation } = useForm();
    const { userInformation } = useAuth();


    // Methos
    const validations = (values: any) => {
        const errors: any = {};

        if (!values.departamentoID) {
            errors.departamentoID = 'Requerido';
        }

        if (!values.puestoID) {
            errors.puestoID = 'Requerido';
        }

        if (!values.nombreUsuario) {
            errors.nombreUsuario = 'Requerido';
        } else if (values.nombreUsuario.trim().split(" ").length > 1) {
            errors.nombreUsuario = 'No puede tener espacios en blanco';
        }


        if (!values.esAdministrador) {
            errors.esAdministrador = 'Requerido';
        }

        if (mode === 'Update') {

            if (!!values.confirmClave && !values.clave) {
                errors.clave = "Requerido";
            } else if (!!values.clave) {
                validatePassword(values, errors);
            }

            if (!!values.clave && !values.confirmClave) {
                errors.confirmClave = 'Requerido';
            } else if (values.confirmClave !== values.clave && !!values.clave) {
                errors.confirmClave = 'No es igual a la anterior';
            }
        } else {
            if (!values.clave) {
                errors.clave = 'Requerido';
            } else {
                validatePassword(values, errors);
            }

            if (!values.confirmClave) {
                errors.confirmClave = 'Requerido';
            } else if (values.confirmClave !== values.clave) {
                errors.confirmClave = 'No es igual a la anterior';
            }
        }

        if (!values.temporal) {
            errors.temporal = 'Requerido';
        }

        if (values.temporal === "true") {
            if (!values.fechaDesde) {
                errors.fechaDesde = 'Requerido';
            }

            if (!values.fechaHasta) {
                errors.fechaHasta = 'Requerido';
            } else if (new Date(values.fechaHasta)?.getTime() < new Date(values.fechaDesde)?.getTime()) {
                errors.fechaHasta = "No puede ser menor que Fecha Desde";
            }
        }

        return errors;
    }

    const validatePassword = (values: any, errors: any) => {
        if (values.clave.length < 8) {
            errors.clave = 'Debe tener mínimo 8 carácteres';
        } else if (!hasNumber(values.clave)) {
            errors.clave = 'Debe tener al menos un número';
        } else if (!hasUpperChar(values.clave)) {
            errors.clave = 'Debe tener al menos una letra mayúscula';
        } else if (!hasLowerChar(values.clave)) {
            errors.clave = 'Debe tener al menos una letra minúscula';
        } else if (!hasSymbols(values.clave)) {
            errors.clave = 'Debe tener al menos una símbolo especial';
        }
    }

    // Form
    const UserForm = useFormik({
        initialValues: { departamentoID: "", puestoID: "", codigoEmpleado: "", fotoPerfil: "", nombreUsuario: "", esAdministrador: "", clave: "", confirmClave: "", temporal: "", fechaDesde: "", fechaHasta: "" },
        validate: validations,
        onSubmit: (values: any) => console.log(values),
    });

    useEffect(() => {
        UserForm.validateForm().then((response) => {
            if (!!userInformationForm) {
                UserForm.setValues({
                    departamentoID: !!userInformationForm.usuarioProyecto?.departamentoID ? userInformationForm.usuarioProyecto!.departamentoID.toString() : "",
                    puestoID: !!userInformationForm.usuarioProyecto?.puestoID ? userInformationForm.usuarioProyecto!.puestoID!.toString() : "",
                    codigoEmpleado: userInformationForm.codigoEmpleado!,
                    fotoPerfil: !!userInformationForm.fotoPerfil ? userInformationForm.fotoPerfil : "",

                    //
                    nombreUsuario: (mode === 'Add') ? userNameCreation : userInformationForm.nombreUsuario!,
                    //

                    esAdministrador: !!userInformationForm.usuarioProyecto?.esAdministrador ? userInformationForm.usuarioProyecto!.esAdministrador.toString() : 'false',

                    //
                    clave: (mode === 'Update') ? "" : userInformationForm.usuarioProyecto?.clave!,
                    confirmClave: (mode === 'Update') ? "" : userInformationForm.usuarioProyecto?.confirmClave!,
                    temporal: !!userInformationForm!.usuarioProyecto?.fechaHasta ? "true" : "false",
                    //

                    fechaDesde: userInformationForm.usuarioProyecto?.fechaDesde!,
                    fechaHasta: !!userInformationForm.usuarioProyecto?.fechaHasta ? userInformationForm.usuarioProyecto!.fechaHasta : "",
                });
            }

            if (JSON.stringify(response) == '{}') {
                setCanGoNext(true);
            } else {
                setCanGoNext(false);
            }
        });
        setCanGoBack(true);
    }, [])


    // Effects
    useEffect(() => {
        setUserInformationForm({
            ...userInformationForm!,
            codigoEmpleado: UserForm.values.codigoEmpleado,
            fotoPerfil: UserForm.values.fotoPerfil,

            //
            nombreUsuario: mode === 'Update' ? UserForm.values.nombreUsuario : userNameCreation,
            //

            usuarioProyecto:
            {
                ...userInformationForm?.usuarioProyecto!,
                departamentoID: !!UserForm.values.departamentoID ? parseInt(UserForm.values.departamentoID) : null,
                puestoID: !!UserForm.values.puestoID ? parseInt(UserForm.values.puestoID) : null,
                esAdministrador: UserForm.values.esAdministrador.toLowerCase() === 'true' ? true : false,

                clave: !!UserForm.values.clave ? UserForm.values.clave : null,
                confirmClave: UserForm.values.confirmClave,
                temporal: UserForm.values.temporal,

                fechaDesde: !!UserForm.values.fechaDesde ? UserForm.values.fechaDesde : null,
                fechaHasta: !!UserForm.values.fechaHasta ? UserForm.values.fechaHasta : null,
            }
        });

        if (JSON.stringify(UserForm.errors) == '{}') {
            setCanGoNext(true);
        } else {
            setCanGoNext(false);
        }
    }, [UserForm.values, UserForm.isValid]);

    return (
        <div style={{ marginTop: 20 }}>
            <GroupRow>
                <MarginInput width="45%">
                    <label>Departamento:</label>
                    <SelectBox
                        value={UserForm.values.departamentoID}
                        defaultValue={userInformationForm?.usuarioProyecto?.departamentoID}
                        placeholder={"Departamento"}
                        disabled={false}
                        allowClear={false}
                        loading={loadingDeparment}
                        onChange={(value: string) => UserForm.setValues({ ...UserForm.values, departamentoID: value, puestoID: "" })}
                        options={listDepartment.map(dep => ({ key: dep.departamentoGUID, value: dep.departamentoID.toString(), text: dep.nombre }))}
                        backgroundColor={COLORS.white_color2(1)}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{UserForm.errors.departamentoID && UserForm.errors.departamentoID}</Paint>
                    </p>
                </MarginInput>

                <MarginInput width="45%">
                    <label>Puesto:</label>
                    <SelectBox
                        value={UserForm.values.puestoID}
                        defaultValue={userInformationForm?.usuarioProyecto?.puestoID}
                        placeholder={"Puesto"}
                        disabled={!!!UserForm.values.departamentoID}
                        allowClear={false}
                        loading={loadingPuesto}
                        onChange={(value: string) => UserForm.setFieldValue('puestoID', value)}
                        options={listPuesto.filter(puest => puest.departamentoID.toString() === UserForm.values.departamentoID).map(pu => ({ key: pu.nombre + pu.puestoID, value: pu.puestoID.toString(), text: pu.nombre }))}
                        backgroundColor={COLORS.white_color2(1)}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{UserForm.errors.puestoID && UserForm.errors.puestoID}</Paint>
                    </p>
                </MarginInput>
            </GroupRow>

            <GroupRow>
                <MarginInput width="45%">
                    <label>Codigo Empleado:</label>
                    <EditTextForm
                        value={UserForm.values.codigoEmpleado}
                        onChange={UserForm.handleChange}
                        backgroundcolor={COLORS.white_color2(1)}
                        name={"codigoEmpleado"}
                        placeholder={"Codigo Empleado"}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        active={true}
                        type={'text'}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{UserForm.errors.codigoEmpleado && UserForm.errors.codigoEmpleado}</Paint>
                    </p>
                </MarginInput>

                <MarginInput width="45%">
                    <label>Foto de perfil:</label>
                    <InputImage
                        value={UserForm.values.fotoPerfil}
                        onChange={(value: string) => UserForm.setFieldValue("fotoPerfil", value)}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{UserForm.errors.fotoPerfil && UserForm.errors.fotoPerfil}</Paint>
                    </p>
                </MarginInput>
            </GroupRow>

            <GroupRow>
                <MarginInput width="45%">
                    <label>Nombre de usuario:</label>
                    <EditTextForm
                        value={UserForm.values.nombreUsuario}
                        onChange={UserForm.handleChange}
                        backgroundcolor={COLORS.white_color2(1)}
                        name={"nombreUsuario"}
                        placeholder={"Nombre de Usuario"}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        active={mode === 'Update'}
                        type={'text'}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{UserForm.errors.nombreUsuario && UserForm.errors.nombreUsuario}</Paint>
                    </p>
                </MarginInput>

                <MarginInput width="45%">
                    <label>Administrador:</label>
                    <SelectBox
                        value={UserForm.values.esAdministrador}
                        defaultValue={userInformationForm?.usuarioProyecto?.esAdministrador}
                        placeholder={"¿Será administrador?"}
                        disabled={userInformation?.usuarioProyecto?.esAdministrador ? false : true}
                        allowClear={false}
                        loading={loadingDeparment}
                        onChange={(value: string) => UserForm.setFieldValue('esAdministrador', value)}
                        options={[{ key: 'AdmSi', value: 'true', text: 'Si' }, { key: 'AdmNo', value: 'false', text: 'No' }]}
                        backgroundColor={COLORS.white_color2(1)}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{UserForm.errors.fotoPerfil && UserForm.errors.fotoPerfil}</Paint>
                    </p>
                </MarginInput>
            </GroupRow>

            <GroupRow>
                <MarginInput width="45%">
                    <label>{mode === 'Add' ? "Contraseña" : "Nueva contraseña"}</label>
                    <EditTextForm
                        value={UserForm.values.clave}
                        onChange={UserForm.handleChange}
                        backgroundcolor={COLORS.white_color2(1)}
                        name={"clave"}
                        placeholder={"Contraseña"}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        active={true}
                        type={'password'}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{UserForm.errors.clave && UserForm.errors.clave}</Paint>
                    </p>
                </MarginInput>

                <MarginInput width="45%">
                    <label>Confirmar contraseña:</label>
                    <EditTextForm
                        value={UserForm.values.confirmClave}
                        onChange={UserForm.handleChange}
                        backgroundcolor={COLORS.white_color2(1)}
                        name={"confirmClave"}
                        placeholder={"Confirmar contraseña"}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        active={true}
                        type={'password'}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{UserForm.errors.confirmClave && UserForm.errors.confirmClave}</Paint>
                    </p>
                </MarginInput>
            </GroupRow>

            <GroupRow>
                <MarginInput width="30%">
                    <label>Temporal</label>
                    <SelectBox
                        value={UserForm.values.temporal}
                        defaultValue={!!userInformationForm?.usuarioProyecto?.fechaHasta ? "true" : "false"}
                        placeholder={"¿Será temporal?"}
                        disabled={false}
                        allowClear={false}
                        loading={loadingDeparment}
                        onChange={(value: string) => { UserForm.setValues({ ...UserForm.values, temporal: value, fechaHasta: value == 'false' ? "" : UserForm.values.fechaHasta }) }}
                        options={[{ key: 'tempSi', value: "true", text: 'Si' }, { key: 'tempNo', value: "false", text: 'No' }]}
                        backgroundColor={COLORS.white_color2(1)}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{UserForm.errors.temporal && UserForm.errors.temporal}</Paint>
                    </p>
                </MarginInput>

                <MarginInput width="30%">
                    <label>Desde:</label>
                    <EditTextForm
                        value={UserForm.values.fechaDesde?.split('T')[0]}
                        onChange={UserForm.handleChange}
                        backgroundcolor={COLORS.white_color2(1)}
                        name={"fechaDesde"}
                        placeholder={"Desde"}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        active={true}
                        type={'date'}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{UserForm.errors.fechaDesde && UserForm.errors.fechaDesde}</Paint>
                    </p>
                </MarginInput>

                <MarginInput width="30%">
                    <label>Hasta:</label>
                    <EditTextForm
                        value={UserForm.values.fechaHasta?.split('T')[0]}
                        onChange={UserForm.handleChange}
                        backgroundcolor={COLORS.white_color2(1)}
                        name={"fechaHasta"}
                        placeholder={"Hasta"}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        active={UserForm.values.temporal === 'true'}
                        type={'date'}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{UserForm.errors.fechaHasta && UserForm.errors.fechaHasta}</Paint>
                    </p>
                </MarginInput>
            </GroupRow>
        </div>
    );
}

export default StepThree;